<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ec_code,eq_name,eq_code"
      placeholder="请输入单据编号或设备名称"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.ec_id"
        :to="'/oa/equipment_check/'+ item.ec_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.eq_name}}</p>
          <p class="list-item-muted">{{item.eq_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ec_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ec_status!='已审核'}"
          >{{item.ec_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}台</label>
    </div>
    <add-button to="/oa/equipment_check_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/equipmentCheck/list",
      filters: [
       {
          type: "date",
          name: "ec_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "ec_status_code='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "ec_status_code='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>